/* Moonji theme JS - vanilla, no dependencies. */
(function () {
  'use strict';
  var R = window.moonji.routes;

  /* ---------------- Cart state + drawer ---------------- */
  var drawer = document.getElementById('cart-drawer');

  function fetchCart() {
    return fetch(R.cart).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
    });
    if (!drawer) return;
    var label = drawer.querySelector('.js-cart-count-label');
    if (label) label.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var subtotal = drawer.querySelector('.js-cart-subtotal');
    if (subtotal) subtotal.textContent = window.moonji.money(cart.total_price);
    var list = drawer.querySelector('.js-cart-items');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }
    list.innerHTML = cart.items.map(function (item) {
      // Shopify's cart.js returns absolute CDN URLs; the dev harness returns asset filenames.
      var imgSrc = item.image && item.image.indexOf('http') === 0 ? item.image : '/assets/' + item.image;
      return (
        '<div class="cart-line">' +
          '<img src="' + imgSrc + '" alt="" width="72" height="72" loading="lazy">' +
          '<div class="cart-line__info">' +
            '<span class="cart-line__title">' + item.product_title + '</span>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-line__variant">' + item.variant_title + '</span>' : '') +
            (item.properties && item.properties._bundle ? '<span class="cart-line__bundle">Part of your Moonji case</span>' : '') +
            '<span class="cart-line__price">' + window.moonji.money(item.price) + ' × ' + item.quantity + '</span>' +
          '</div>' +
          '<strong class="cart-line__total">' + window.moonji.money(item.final_line_price) + '</strong>' +
          '<button type="button" class="icon-btn js-cart-remove" data-line-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  function openDrawer() {
    if (!drawer) return;
    fetchCart().then(renderCart);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var closeBtn = drawer.querySelector('.js-cart-close[aria-label]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function addToCart(items) {
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return fetchCart();
    }).then(function (cart) {
      renderCart(cart);
      openDrawer();
      return cart;
    });
  }
  window.moonji.addToCart = addToCart;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('.js-cart-open');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('.js-cart-close')) { closeDrawer(); return; }

    var remove = e.target.closest('.js-cart-remove');
    if (remove) {
      fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.lineKey, quantity: 0 }),
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
      return;
    }

    var quick = e.target.closest('.js-quick-add');
    if (quick && !quick.disabled) {
      var original = quick.textContent;
      quick.disabled = true;
      quick.textContent = 'Adding…';
      addToCart([{ id: Number(quick.dataset.variantId), quantity: 1 }])
        .then(function () { quick.textContent = '✓ Added'; })
        .catch(function () { quick.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { quick.textContent = original; quick.disabled = false; }, 1500);
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileMenu(); }
  });

  fetchCart().then(renderCart);

  /* ---------------- PDP form ---------------- */
  var pdpForm = document.querySelector('.js-product-form');
  if (pdpForm) {
    var variantSelect = document.querySelector('.js-variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        pdpForm.dataset.variantId = variantSelect.value;
        var amount = document.querySelector('.pdp__price .price__amount');
        if (amount && opt.dataset.price) amount.textContent = window.moonji.money(Number(opt.dataset.price));
        var compare = document.querySelector('.pdp__price .price__compare');
        if (compare) {
          var showCompare = Number(opt.dataset.compare) > Number(opt.dataset.price);
          compare.style.display = showCompare ? '' : 'none';
          if (showCompare) compare.textContent = window.moonji.money(Number(opt.dataset.compare));
        }
      });
    }
    var count = pdpForm.querySelector('[data-count]');
    pdpForm.querySelectorAll('.stepper__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(1, Math.min(24, Number(count.textContent) + Number(btn.dataset.step)));
        count.textContent = next;
      });
    });
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submit = pdpForm.querySelector('.js-pdp-add');
      if (submit.disabled) return;
      submit.disabled = true;
      var original = submit.textContent;
      submit.textContent = 'Adding…';
      addToCart([{ id: Number(pdpForm.dataset.variantId), quantity: Number(count.textContent) }])
        .then(function () { submit.textContent = '✓ Added'; })
        .catch(function () { submit.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { submit.textContent = original; submit.disabled = false; }, 1500);
        });
    });
  }

  /* ---------------- Header: solid on scroll ---------------- */
  var header = document.querySelector('.js-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('.js-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  }
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  /* ---------------- Desktop dropdowns (click + keyboard, hover via CSS) ---------------- */
  document.querySelectorAll('.js-dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.js-dropdown-toggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.has-dropdown')) {
      document.querySelectorAll('.js-dropdown-toggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });

  /* ---------------- Hero video: reduced motion + error fallback ---------------- */
  var heroVideo = document.querySelector('.js-hero-video');
  if (heroVideo) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
      heroVideo.style.display = 'none';
    }
    heroVideo.addEventListener('error', function () { heroVideo.style.display = 'none'; }, true);
    var source = heroVideo.querySelector('source');
    if (source) source.addEventListener('error', function () { heroVideo.style.display = 'none'; });
  }
})();
